import React, { Suspense, lazy } from 'react';

const EditorContextProvider = lazy(() => import('../editor-context-provider'));

const AsyncEditorContextProvider = props =>
  (
    <Suspense fallback={(<div className="-wa-loading-editor-context" />)}>
      <EditorContextProvider {...props} />
    </Suspense>
  );

export default AsyncEditorContextProvider;